import { Money, formatMoney } from '@betterment/core';
import { HStack, Text, VStack } from '@betterment/samba-react';
import { ReturnsText } from '@betterment/shared-components';

import { DateRangeOption } from '../../../../../../../graphql/schema';
import { timePeriodForValueLabel } from '../../timePeriods';

type PostMarketHoursType = {
  latestPriceAmount: Money;
  latestReturnsAmount: Money;
  latestReturnsPercentage: number;
  dateRangeOption: DateRangeOption;
};

export const PostMarketHours = ({
  latestPriceAmount,
  latestReturnsAmount,
  latestReturnsPercentage,
  dateRangeOption,
}: PostMarketHoursType) => {
  return (
    <VStack>
      <Text color="text" variant="text100">
        Price at market close
      </Text>
      <Text variant="text400">{formatMoney(latestPriceAmount, 'default')}</Text>
      <HStack css={{ gap: 'space.50', alignItems: 'center' }}>
        <ReturnsText
          variant="text100"
          negativeToken="text.critical"
          amount={latestReturnsAmount}
          percent={latestReturnsPercentage}
        />
        <Text variant="text100" color="text.weak">
          {timePeriodForValueLabel(dateRangeOption)}
        </Text>
      </HStack>
    </VStack>
  );
};
